import React from 'react'
import logo from '../../../assets/static/logo-livelo.png'
const LogotipoLivelo = () => (
	<img className="logotipo-livelo" src={logo} alt="Livelo" />
)

export default LogotipoLivelo
